
  // ═══════════════════════════════════════════════════════════════
  // VARIABLES À CUSTOMISER POUR CHAQUE PAGE
  // ═══════════════════════════════════════════════════════════════
  const CONFIG = {
    lieuCible: "Chomo - Sanctuaire des bois brûlés",
    splatURL: "./assets/chomo/models/chomo_sanctuaire_500k_pycut_15000_clean.compressed.ply",
    meshURL: null,
    planURL: null,
    camPosX: 5,
    camPosY: 5,
    camPosZ: 1,
    camRotX: 0,
    camRotY: 0,
    camRotZ: 0,
    camTargetX: 0.2,
    camTargetY: 0,
    camTargetZ: 0,
    camMinDistance: 0.1,
    camMaxDistance: 25
  };
  // ═══════════════════════════════════════════════════════════════
  
  import { initViewer } from './spark_viewer.js';
  initViewer(CONFIG);
